module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-scary.e3b59826.png";